<template>
  <div class="c-form-item-sys-config-data-editor">
    <c-form-items v-bind="innerFormItemsAttrs" :model="model"></c-form-items>
  </div>
</template>

<script setup lang="ts">
import { _, computed, watch } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
  }>(),
  {}
)

const innerFormItemsAttrs = computed(() => {
  return {
    showOperation: false,
    span: 12,
    items: [
      {
        label: '数据配置',
        type: 'textarea',
        prop: `${props.prop}.b`,
        maxlength: 5000,
        span: 24,
        required: true
      },
      { label: '叶子节点', type: 'switch', prop: `${props.prop}.a` }
    ]
  }
})
</script>

<style lang="scss" scoped></style>
